import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import { ProductState } from './ProductStates';
import { OrderState } from './OrderStates';
import { SetUpState } from './SetUpStates';
import { SessionStates } from './SessionStates';
import { ReportStates } from './ReportStates';
import { DashboardState } from './DashboardState';
import { ReconciliationState } from './ReconciliationStates';
import { VoucherState } from './VoucherStates';
import { PersonalizationState } from './PersonalizationState';
import { ProfileState } from './ProfileState';
import { UsageOverviewState } from './UsageOverviewState';
import { GlobalComponentState } from './GlobalComponentState';
import { AdjustmentState } from './AdjustmentState';

export const Context = () => {
        return {
                tool_state: ToolStates(),
                navigation_state: NavigationStates(),
                switching_state: SwitchingState(),
                tool_category_state: ToolCategoryState(),
                notif_state: NotifState(),
                product_state: ProductState(),
                order_state: OrderState(),
                setup_state: SetUpState(),
                session_state: SessionStates(),
                report_state: ReportStates(),
                dashboard_state: DashboardState(),
                reconciliation_state: ReconciliationState(),
                voucher_state: VoucherState(),
                personalization_state: PersonalizationState(),
                profile_state: ProfileState(),
                usage_state: UsageOverviewState(),
                global_component_state: GlobalComponentState(),
                adjustment_state: AdjustmentState()
        }
}